import script from "./esFinancialChannelForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./esFinancialChannelForm.vue?vue&type=script&setup=true&lang=ts"

import "./esFinancialChannelForm.vue?vue&type=style&index=0&id=49c06a0b&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49c06a0b"]])

export default __exports__